var _path, _rect, _rect2, _rect3, _path2, _path3, _rect4, _path4, _circle, _rect5, _rect6, _path5, _path6, _path7, _rect7, _rect8, _path8, _rect9, _rect10, _path9, _rect11, _rect12, _path10, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path11, _path12, _rect19, _rect20, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotelAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2175 9.28516C27.289 9.28516 20.0405 16.5216 20.0405 25.4501V57.636H21.9846V25.4621C21.9846 17.6017 28.357 11.2413 36.2055 11.2413C44.066 11.2413 50.4263 17.6137 50.4263 25.4621V57.648H52.3705V25.4621C52.3945 16.5216 45.146 9.28516 36.2175 9.28516Z",
    fill: "#E8AE4C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5281,
    y: 57.6465,
    width: 47.3788,
    height: 3.24019,
    fill: "#E8AE4C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5281,
    y: 59.2676,
    width: 47.3788,
    height: 1.6201,
    fill: "#EABC6B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7563,
    y: 60.8867,
    width: 1.57209,
    height: 2.89217,
    fill: "#E8AE4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8726 65.6624C19.8726 67.5105 18.3725 68.9986 16.5364 68.9986C14.6883 68.9986 13.2002 67.4985 13.2002 65.6624C13.2002 63.8143 14.7003 62.3262 16.5364 62.3262C18.3725 62.3262 19.8726 63.8263 19.8726 65.6624Z",
    fill: "#393939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3724 65.6623C18.3724 66.6703 17.5564 67.4984 16.5363 67.4984C15.5282 67.4984 14.7002 66.6823 14.7002 65.6623C14.7002 64.6542 15.5162 63.8262 16.5363 63.8262C17.5444 63.8382 18.3724 64.6542 18.3724 65.6623Z",
    fill: "#5E5E5E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1187,
    y: 60.8867,
    width: 1.57209,
    height: 2.89217,
    fill: "#E8AE4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2469 65.6624C59.2469 67.5105 57.7468 68.9986 55.9107 68.9986C54.0626 68.9986 52.5745 67.4985 52.5745 65.6624C52.5745 63.8143 54.0746 62.3262 55.9107 62.3262C57.7468 62.3262 59.2469 63.8263 59.2469 65.6624Z",
    fill: "#393939"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.9106,
    cy: 65.6623,
    r: 1.83611,
    fill: "#5E5E5E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1726,
    y: 31.7637,
    width: 0.84005,
    height: 2.82017,
    fill: "#717877"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26.3647,
    y: 31.7637,
    width: 0.84005,
    height: 2.82017,
    fill: "#717877"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6013 55.8113H14.0641C12.9241 55.8113 12 54.8872 12 53.7472V36.6462C12 35.5061 12.9241 34.582 14.0641 34.582H33.6013C34.7414 34.582 35.6654 35.5061 35.6654 36.6462V53.7352C35.6654 54.8872 34.7414 55.8113 33.6013 55.8113Z",
    fill: "#291482"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0962 55.8125V56.5205C15.0962 57.1446 15.6002 57.6486 16.2243 57.6486C16.8483 57.6486 17.3523 57.1446 17.3523 56.5205V55.8125H15.0962Z",
    fill: "#929C9A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6851 55.8125V56.5205C30.6851 57.1446 31.1891 57.6486 31.8131 57.6486C32.4372 57.6486 32.9412 57.1446 32.9412 56.5205V55.8125H30.6851Z",
    fill: "#929C9A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0962,
    y: 55.8125,
    width: 2.25613,
    height: 0.708042,
    fill: "#636968"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30.6851,
    y: 55.8125,
    width: 2.25613,
    height: 0.708042,
    fill: "#636968"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6849 31.5825V32.6025C27.6849 32.7585 27.5649 32.8786 27.4088 32.8786H19.9684C19.8124 32.8786 19.6924 32.7585 19.6924 32.6025V31.5825C19.6924 31.2105 20.0404 30.8984 20.4604 30.8984H26.8928C27.3368 30.8984 27.6849 31.2105 27.6849 31.5825Z",
    fill: "#929C9A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7893,
    y: 41.8672,
    width: 0.552033,
    height: 1.84811,
    fill: "#717877"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8577,
    y: 41.8672,
    width: 0.552033,
    height: 1.84811,
    fill: "#717877"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5979 57.6477H30.7811C30.0371 57.6477 29.425 57.0356 29.425 56.2916V45.0709C29.425 44.3269 30.0371 43.7148 30.7811 43.7148H43.5979C44.3419 43.7148 44.954 44.3269 44.954 45.0709V56.2916C44.954 57.0356 44.3539 57.6477 43.5979 57.6477Z",
    fill: "#ACA2FF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6892,
    y: 43.7148,
    width: 1.10407,
    height: 13.9208,
    fill: "#616FB3"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5857,
    y: 43.7148,
    width: 1.10407,
    height: 13.9208,
    fill: "#616FB3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7216 41.7468V42.4188C39.7216 42.5148 39.6376 42.5988 39.5416 42.5988H34.6573C34.5613 42.5988 34.4773 42.5148 34.4773 42.4188V41.7468C34.4773 41.4947 34.7053 41.3027 34.9813 41.3027H39.2056C39.4936 41.3027 39.7216 41.5067 39.7216 41.7468Z",
    fill: "#929C9A"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8696,
    y: 50.002,
    width: 17.8091,
    height: 7.64446,
    fill: "#616FB3"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 38.8696,
    y: 50.002,
    width: 17.8091,
    height: 3.82823,
    fill: "#291482"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 41.2097,
    y: 53.0508,
    width: 1.6681,
    height: 1.93212,
    fill: "#929C9A"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 52.6704,
    y: 53.0508,
    width: 1.6681,
    height: 1.93212,
    fill: "#929C9A"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 49.9341,
    y: 53.8184,
    width: 0.684041,
    height: 2.26814,
    fill: "#929C9A"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9419,
    y: 53.8184,
    width: 0.684041,
    height: 2.26814,
    fill: "#929C9A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5579 56.2313V55.4152C44.5579 55.2952 44.6539 55.1992 44.7739 55.1992H50.7622C50.8822 55.1992 50.9782 55.2952 50.9782 55.4152V56.2313C50.9782 56.5313 50.7022 56.7833 50.3542 56.7833H45.1699C44.8339 56.7833 44.5579 56.5433 44.5579 56.2313Z",
    fill: "#717877"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.28 31.2225V57.636H16.2241V31.2225C16.2241 20.1818 25.1767 11.2293 36.2173 11.2293C47.258 11.2293 56.2105 20.1818 56.2105 31.2225V57.636H58.1546V31.2225C58.1546 19.1017 48.3381 9.28516 36.2173 9.28516C24.1086 9.28516 14.28 19.1137 14.28 31.2225Z",
    fill: "#EABC6B"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2451,
    y: 15.2969,
    width: 13.9568,
    height: 1.94412,
    fill: "#EABC6B"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2454,
    y: 4.67578,
    width: 1.94412,
    height: 11.5927,
    fill: "#EABC6B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8936 4.67616C38.8936 6.15225 37.6935 7.35232 36.2174 7.35232C34.7413 7.35232 33.5413 6.15225 33.5413 4.67616C33.5413 3.20007 34.7413 2 36.2174 2C37.6935 2 38.8936 3.20007 38.8936 4.67616Z",
    fill: "#EABC6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelAddressIcon);
export default __webpack_public_path__ + "static/media/hotel-address-icon.602025b63a03c20c4e458f93ae1a17c9.svg";
export { ForwardRef as ReactComponent };